import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiMail, FiMapPin } from 'react-icons/fi';
import './Contact.css';

const Contact = () => {
  const { t } = useTranslation();

  const contactInfo = [
    {
      icon: FiMapPin,
      title: t('contact.address'),
      content: t('contact.info.address'),
      link: 'https://maps.google.com/?q=Markstraße+37,+13409+Berlin'
    },
    {
      icon: FiMail,
      title: t('contact.email'),
      content: t('contact.info.email'),
      link: `mailto:${t('contact.info.email')}`
    }
  ];

  return (
    <motion.div
      className="contact-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1>{t('contact.title')}</h1>
            <p className="hero-subtitle">{t('contact.subtitle')}</p>
          </motion.div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content-component section-padding">
        <div className="container">
          <div className="contact-info-section">
            <motion.div
              className="section-header text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2>{t('contact.getInTouch')}</h2>
              <p>{t('contact.contactDescription')}</p>
            </motion.div>

            <div className="contact-cards">
              {contactInfo.map((info, index) => (
                <motion.div
                  key={index}
                  className="contact-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -10 }}
                >
                  <div className="contact-icon">
                    <info.icon />
                  </div>
                  <div className="contact-text">
                    <h3>{info.title}</h3>
                    <a href={info.link} target="_blank" rel="noopener noreferrer" className="contact-link">
                      {info.content}
                    </a>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section section-padding">
        <div className="container">
          <motion.div
            className="section-header text-center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>{t('contact.ourLocation')}</h2>
            <p>{t('contact.locationDescription')}</p>
          </motion.div>

          <motion.div
            className="map-container"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="map-placeholder">
              <FiMapPin />
              <h3>DLDMN Baumanagement GmbH</h3>
              <p>Markstraße 37, 13409 Berlin</p>
              <motion.a
                href="https://maps.google.com/?q=Markstraße+37,+13409+Berlin"
                target="_blank"
                rel="noopener noreferrer"
                className="map-button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {t('contact.viewOnMaps')}
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default Contact;